import React, { useState, useEffect } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { useSettings } from "../../context/SettingsContext";

export default function FloatingButtons() {
  const [visible, setVisible] = useState(false);
  const { get } = useSettings();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(t);
  }, []);

  const whatsapp = get("whatsapp_number")?.replace(/\D/g, "");
  const call = get("call_number");
  const waMsg = get("whatsapp_message") || "Hello Sava Fresh, I am interested in your products.";

  if (!visible) return null;

  return (
    <>
      {/* WhatsApp */}
      {whatsapp && (
        <a
          href={`https://wa.me/${whatsapp}?text=${encodeURIComponent(waMsg)}`}
          target="_blank"
          rel="noopener noreferrer"
          className="floating-btn floating-whatsapp hover:scale-110 hover:-rotate-6"
          title="Chat on WhatsApp"
          style={{
            position: "fixed", right: "24px", bottom: "88px", zIndex: 1000,
            width: "52px", height: "52px", borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "#25D366", boxShadow: "0 4px 20px rgba(37,211,102,0.4)",
            transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
          }}
        >
          <svg viewBox="0 0 24 24" className="w-6 h-6 fill-white" xmlns="http://www.w3.org/2000/svg">
            <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.5-5.729-1.455L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.858.002-2.634-1.02-5.11-2.881-6.973C16.634 1.912 14.16 1.882 12.01 1.88c-5.446 0-9.875 4.423-9.879 9.861-.001 1.769.467 3.498 1.357 5.021L2.488 20.35l3.896-1.022.263.126zm10.743-5.316c-.293-.147-1.733-.856-2.002-.954-.269-.099-.465-.148-.659.148-.195.297-.754.954-.926 1.15-.172.197-.344.22-.637.073-.293-.147-1.238-.456-2.361-1.459-.873-.78-1.463-1.743-1.635-2.04-.173-.296-.018-.457.129-.603.132-.131.294-.343.441-.515.146-.171.196-.294.294-.49.098-.196.05-.367-.025-.515-.074-.147-.659-1.59-.903-2.175-.237-.573-.478-.496-.659-.505-.169-.008-.364-.01-.559-.01-.196 0-.514.073-.783.367-.269.294-1.025 1.004-1.025 2.449s1.047 2.839 1.192 3.036c.147.197 2.062 3.149 4.996 4.414.697.3 1.242.48 1.666.615.702.223 1.342.192 1.849.116.564-.085 1.734-.707 1.979-1.39.244-.683.244-1.272.172-1.39-.072-.119-.268-.196-.561-.343z"/>
          </svg>
        </a>
      )}

      {/* Call */}
      {call && (
        <a
          href={`tel:${call}`}
          className="floating-btn floating-call"
          title="Call us"
          style={{
            position: "fixed", right: "24px", bottom: "24px", zIndex: 1000,
            width: "52px", height: "52px", borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            background: "#113339", boxShadow: "0 4px 20px rgba(17,51,57,0.4)",
            transition: "all 0.3s ease",
          }}
        >
          <Phone className="w-5 h-5 text-white" />
        </a>
      )}
    </>
  );
}
